import {
  addDays,
  format,
  isAfter,
  isBefore,
  isEqual,
  parseISO
} from "date-fns";
import { CaseStatusEnum, Fragments } from "requests";
import { MedicalCase, SelectionItem } from "./types";

export const filterStoredCases = (
  storedCases: Fragments.StoredMedicalCase[],
  filter: any,
  search: string | undefined
) => {
  let result = [...storedCases];

  if (filter?.date) {
    const currentDay = new Date(filter?.date);
    const nextDay = addDays(currentDay, 1);

    result = result.filter(medCase => {
      const createdAt = parseISO(medCase?.client?.patient?.procedureDate);
      return (
        (isAfter(createdAt, currentDay) || isEqual(createdAt, currentDay)) &&
        isBefore(createdAt, nextDay)
      );
    });
  }
  if (search) {
    result = result.filter(medCase =>
      medCase.name.toLowerCase().includes(search || "")
    );
  }
  if (filter.status) {
    result = result.filter(medCase =>
      (filter.status as CaseStatusEnum[]).includes(medCase.status)
    );
  }
  if (filter.procedures) {
    result = result.filter(medCase => {
      const procedures = medCase.client.patient.procedures || [];
      return (filter.procedures as string[]).some(procId =>
        procedures.includes(procId)
      );
    });
  }
  if (filter.doctors) {
    const docIds: number[] = filter.doctors.map((docId: string) => +docId);

    result = result.filter(medCase => {
      const dropOffDoctor = medCase.client.patient.dropOff.doctor;
      const dropOffMatch = dropOffDoctor && docIds.includes(dropOffDoctor);
      return dropOffMatch;
    });
  }

  return result;
};

export const getFilterData = (params: any, excludeIds: number[]) => {
  if (!params.filter && !params.search) {
    return { excludeIds };
  }

  const { filter, search } = params;
  const currentDay = filter?.date ? new Date(filter?.date) : new Date();
  const nextDay = format(addDays(currentDay, 1), "MM/dd/y");
  const doctors = filter?.doctors?.map((el: string) => +el);

  return {
    excludeIds,
    ...(search && {
      like: {
        name: search
      }
    }),
    ...(filter?.date && {
      range: {
        client_patient_procedureDate: {
          gte: filter?.date,
          lt: nextDay
        }
      }
    }),
    ...(filter?.status && {
      OR: [
        {
          equal: { status: filter?.status?.[0] || "" }
        },
        !!filter?.status?.[1] && {
          equal: { status: filter?.status?.[1] || "" }
        }
      ].filter(Boolean)
    }),
    in: {
      client_patient_dropOff_doctor_id: doctors
    },
    procedures: filter?.procedures
  };
};

export const getProps = (
  medCase: MedicalCase | Fragments.StoredMedicalCase,
  selection: SelectionItem[]
) => ({
  key: medCase._id,
  id: medCase._id,
  name: medCase.name,
  selected: !!selection.find(mc => mc._id === medCase._id),
  procedureDate: medCase.client.patient.procedureDate,
  createdFrom: medCase.createdFrom || null
});
